import { Link } from 'react-router-dom';

interface Product {
  id: number;
  name: string;
  nameEn: string;
  originalPrice: number;
  salePrice: number;
  discount: number;
  image: string;
  isPreorder?: number | boolean; // 新增預售屬性
}

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  // 兼容不同命名風格
  const isPreorder = product.isPreorder ?? (product as any).is_preorder;

  return (
    <Link
      to={`/product/${product.id}`}
      // 💡 關鍵：加上 relative 讓預售標籤能相對於卡片定位
      className="relative group block bg-white rounded-xl overflow-hidden border border-fog-mid hover:border-fog-dark transition-all duration-300 hover:shadow-lg cursor-pointer"
      data-product-shop
    >
      {/* 💡 新增：預售標籤條件渲染 */}
      {Number(isPreorder) === 1 && (
        <div className="absolute top-0 left-0 z-10 w-32 h-32 overflow-hidden pointer-events-none">
          <span className="absolute top-7 -left-10 w-40 -rotate-45 bg-accent-orange text-white text-sm font-bold text-center py-1.5 shadow-md whitespace-nowrap">
            預售
          </span>
        </div>
      )}

      {/* Image */}
      <div className="relative aspect-square overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          title={`${product.name} - Steam Key`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>

      {/* Info */}
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-text-dark mb-2.5 line-clamp-1">
          {product.name}
        </h3>
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-xs text-text-gray line-through">
              NT${product.originalPrice}
            </span>
            <span className="text-sm md:text-base font-bold text-accent-orange">
              NT${product.salePrice}
            </span>
          </div>
          <div className="flex items-center justify-center bg-discount-yellow rounded-md px-2 py-1.5 h-10">
            <span className="text-white text-xs font-bold whitespace-nowrap">
              -{product.discount}%
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}